import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getDocumentSignedSignature(documentSignatureId: string) {
  try {
    const response = await apiGet('core','documents-signed/signature/' + documentSignatureId);
    return response;
  } catch (e) { }
}


export async function postDocumentSignedSignature(documentSignatureId: string) {
  try {
    const response = await apiPost('core','documents-signed/signature/' + documentSignatureId, {});
    return response;
  } catch (e) { }
}